<template>
<section id="find-us-in-the-wild" class="bg-blue">
      <div class="container-mid mt-3 mb-4">
        <h2 class="teal mt-1">Let's stay connected!</h2>
        <div class="row gap-1">
          <a class="card-container-outline no-m teal social-buttons" href="https://www.instagram.com/redplusbluestories/" target="_blank">
            <img src="../assets/img/sm_ig.png">
          </a>
          <a class="card-container-outline no-m teal social-buttons" href="https://www.youtube.com/@redbluestories">
            <img src="../assets/img/sm_yt.png">
          </a>
          <a class="card-container-outline no-m teal social-buttons" href="https://www.tiktok.com/@redplusbluestories">
            <img src="../assets/img/sm_tiktok.png">
          </a>
        </div>
        <section id="newsletter-signup" class="container-mid mb-2">
          <NewsletterSignupBlock class="newsletter-reverse-mb" :backToWebsite="false"></NewsletterSignupBlock>
        </section>
      </div>
    </section>
</template>

<script>
import NewsletterSignupBlock from "@/components/NewsletterSignupBlock.vue";
import EventThumbnail from "@/components/EventThumbnail.vue";

export default {
  name: "SmallPreFooter",
  components: {EventThumbnail, NewsletterSignupBlock},
  computed: {
    events() {
      return this.$store.getters.getThreeUpcomingEvents;
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/styles/variables.scss";

#find-us-in-the-wild {
  padding: 2em 0;
  border: 1px solid $blue-hover;
}

.social-buttons {
  img {
    max-height: 60px;
  }
  &:hover {
    background-color: $blue-hover;
  }
}

@media only screen and (max-width: 747px) {
  #find-us-in-the-wild {
    .width-40 {
      width: unset;
    }
  }

  #newsletter-signup {
    margin: 4em auto;
  }
}

</style>